import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isSenderImageOptionDirty(state) {
    var hideSenderImageViewStateOption = !getIsBitSet(8 /* HideSenderImage */);
    var showSenderImageInListView = getFallbackValueIfNull(state.optionState.showSenderImageInListView, hideSenderImageViewStateOption);
    return showSenderImageInListView !== hideSenderImageViewStateOption;
});
//# sourceMappingURL=isSenderImageOptionDirty.js.map